/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Suppression } from 'cio/utils/email-suppression-list';
import { isEmpty } from '@ember/utils';

interface ItemArgs {
  onSelect: (suppression: Suppression) => unknown;
  suppression: Suppression;
  index: string | number;
}

export default class Item extends Component<ItemArgs> {
  @tracked isExpanded = false;

  get isClickable() {
    return !isEmpty(this.args.suppression.reason);
  }

  @action
  onSelectAction() {
    this.args.onSelect(this.args.suppression);
  }

  @action
  toggle() {
    if (!this.isClickable) {
      return;
    }

    this.isExpanded = !this.isExpanded;
  }
}
